import axiosInstanceClient from '../Common/Axios/axiosInstanceClient';
import API from '../Common/Endpoint/serviceConstrants';
export const callHomePageLandingGetApi = async (payload) => {
  const { data = {} } = await axiosInstanceClient.get(API.homePage);
  return data;
};
export const callHomePagePostLoginLandingApi = async (payload) => {
  const { data = {} } = await axiosInstanceClient.get(API.postLoginDetails, {
    params: {
      memberIdentifier: payload?.memberIdentifier,
      cardCode: payload.cardCode,
      cardsNetwork: payload.cardsNetwork
    },
  });
  return data;
};